export default "__VITE_ASSET__BS1UNFVt__"